import { getParameterByName } from './getParameterByName';

export function goToNextPageIfPossible() {
  const nextPage = getParameterByName('next', window.location.search);
  if (isValidHttpUrl(nextPage)) {
    window.open(nextPage!!, '_blank');
  }
}

function isValidHttpUrl(s: string | null) {
  let url;
  try {
    url = new URL(s!!);
  } catch (e) {
    return false;
  }
  return /https?/.test(url.protocol);
}
